import { fetchGraphQL } from "./api"
import type {
  File,
  QueryFilesArgs,
  MutationDeleteFileArgs,
  QueryFileArgs,
} from "../graphql/schema"

const GET_FILES_QUERY = `
  query GetFiles($limit: Int, $offset: Int) {
    files(limit: $limit, offset: $offset) {
      id
      filename
      mimeType
      size
      url
      createdAt
    }
  }
`

const GET_FILE_QUERY = `
  query GetFile($id: ID!) {
    file(id: $id) {
      id
      filename
      mimeType
      size
      url
      createdAt
    }
  }
`

const DELETE_FILE_MUTATION = `
  mutation DeleteFile($id: ID!) {
    deleteFile(id: $id)
  }
`

/**
 * 获取文件列表
 * @param params 分页参数 limit 和 offset
 */
export async function getFiles(
  params: QueryFilesArgs = { limit: 20, offset: 0 }
): Promise<File[]> {
  // 定义返回数据的结构
  type GetFilesResponse = {
    files: File[]
  }

  const data = await fetchGraphQL<GetFilesResponse, QueryFilesArgs>(
    GET_FILES_QUERY,
    {},
    params
  )

  return data.files || []
}

/**
 * 获取单个文件详情
 * @param id 文件 ID
 */
export async function getFile(id: string): Promise<File | null> {
  // 定义返回数据的结构
  type GetFileResponse = {
    file: File | null
  }

  const data = await fetchGraphQL<GetFileResponse, QueryFileArgs>(
    GET_FILE_QUERY,
    {},
    { id }
  )

  return data.file || null
}

/**
 * 删除文件
 * @param id 文件 ID
 * @returns boolean 是否删除成功
 */
export async function deleteFile(
  id: string,
  headers: Record<string, string>
): Promise<boolean> {
  // 定义返回数据的结构
  type DeleteFileResponse = {
    deleteFile: boolean
  }

  const data = await fetchGraphQL<DeleteFileResponse, MutationDeleteFileArgs>(
    DELETE_FILE_MUTATION,
    headers,
    { id }
  )

  // 如果 deleteFile 为 null 或 undefined，默认为 false
  return data.deleteFile ?? false
}
